import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchApiGatewayKeyByIdRequest = {
	apiKeyId: number;
	label: string;
};

export const patchApiGatewayKeyById = createPatchEndpoint<PatchApiGatewayKeyByIdRequest>(
	({ apiKeyId }) => `/api/v3/security/api-gateway-keys/${apiKeyId}`,
	{
		requestTransform: ({ apiKeyId, ...rest }) => rest
	}
);
